/**
 * Server-Sent Events utilities.
 *
 * One import for everything a consumer needs:
 *
 * ```ts
 * import { SseClientService, SseEvent, SSE_ENABLED } from "../../core/sse";
 * ```
 *
 * See ./README.md for usage.
 */
export { SseClientService } from "./sse-client.service";
export { SseFrameDecoder } from "./sse-frame-decoder";
export { parseSseData, toSseEvent } from "./sse.utils";
export { SSE_ENABLED } from "./sse.config";
export {
    SseEvent,
    SseMessage,
    SseOptions,
    SseStreamError,
    SseUntilOptions,
} from "./sse.types";
